<template > 
    <section style="background-color:white" v-resize="onResize"  class="dexter">
        <!-- consulta tramites -->
        <div class="mobile-hide"> 

           <v-card
                class="d-flex justify-center mobile-status-background py-3"
                :color="colorConsultarBackground"
                flat
                height="100%"
                tile
                style="z-index: 3"
            >
                <v-card
                v-for="(item, index) in itemsConsultar"
                :key="index"
                class="align-self-center text-md-h5 d-flex"
                :color="colorConsultarBackground"
                flat
                >
                    <v-card class="align-self-center px-2" flat :color="colorConsultarBackground">

                        <v-btn max-width="100%" outlined class="px-5 py-7 mobile-status-btn bttn-consulta" @click="goValidate(item.text)">
                            <v-card tile plain flat class="text-decoration-none font-weight-black text-none montserrat mobile-status-text bttn-consulta text-wrap"  color="transparent">
                            {{item.text}}
                            </v-card>
                        </v-btn> 
                    </v-card> 
                </v-card>
            </v-card>

        </div>
        <!-- las personas -->
        <div>

            <v-card
            width="100%"
            height="100%"
            class="d-flex flex-row justify-center min-height-mb mx-auto"
            style="border:0;z-index:0;"
            plain
            tile
            flat
            >       
                    <v-card  
                    plain
                    tile
                    max-width="1600px"
                    flat 
                    width="100%" class="d-flex flex-column pt-7  pl-16 personas-mobil"
                    >
                        <div class="nuevo-title  desktop-only">UN NUEVO NUEVO LEÓN</div> 
                        <div class="nuevo-title-black desktop-only">MÁS EFICIENTE</div> 
                        <div class="nuevo-title  mobile-only">UN NUEVO</div> 
                        <div class="nuevo-title  mobile-only">NUEVO LEÓN</div> 
                        <div class="nuevo-title-black mobile-only">MÁS EFICIENTE</div> 
                        <div class="nuevo-sub-title ">{{registrate.text}} </div> 
                          <v-btn width="15%" :color="colorRegistrateBackground" @click="goRegister()" class="pl-7 pr-7 py-6 mt-4 text-decoration-none white--text font-weight-black text-none montserrat bttn-registrate-title">
                            {{registrate.btn}}
                        </v-btn> 
                    </v-card>

                    <v-img
                    class="ml-16  justify-content-end desktop-only "
                    lazy-src="../../assets/img/chicos-web.webp"
                    max-height="100%"
                    max-width="50%"
                    style="z-index:1; position: absolute ; right:0px;background-repeat: round;"
                    src="../../assets/img/chicos-web.webp"
                    ></v-img>

                      <v-img
                    class="ml-16   justify-content-end  desktop-only"
                    lazy-src="../../assets/img/corchete-header-02.webp"
                    max-height="100%"
                    max-width="50%"
                    contain
                    position="right"
                    style="z-index:0; position: absolute;right:0;     background-repeat: round;background-position-x: right !important"
                    src="../../assets/img/corchete-header-02.webp"
                    ></v-img>


                    <v-img
                    class="mobile-only mt-16"
                    lazy-src="../../assets/img/chicos-web.webp"
                    max-height="85%"
                    max-width="85%"
                    width="85%"
                    contain
                    position="right"
                    rigth="0"
                    bottom="0"
                    style="z-index:12 ;position: absolute;right:0;bottom:0 ;background-repeat: round;background-position-x: right !important"
                    src="../../assets/img/chicos-web.webp"
                    ></v-img>
                    
                    <!-- <v-img
                    class="mobile-only"
                    lazy-src="../../assets/img/corchete-fondo.svg"
                    width="100%"
                    min-width="100%"
                    cover
                    style="z-index:0; position: absolute;bottom:7px"
                    src="../../assets/img/corchete-fondo.svg"
                    ></v-img> -->
                    <div
                        class="mobile-only"
                        style="width:100%;min-width:100%;background-color: #fed5b4;height:100%;position:absolute;z-index:0"
                    >
                    </div> 
            </v-card>
        </div>
        <!-- botones categoria tramites -->
        <div class="categoria-tramites" >
            
            <!-- botones de categorias -->
                <div class="d-flex flex-row justify-center  mb-16 overflow-scroll-x no-justify-center" color="transparent"  style="z-index:1;padding-top: 10px;"  plain tile flat  height="100%" >
                        
                        <v-card  
                        flat 
                        plain 
                        tile
                        v-for="(item, index) in categoriasOrdenadas" 
                        :key="index"
                        color="transparent"
                        class="py-2"
                        >
                            <v-btn 
                            height="100%"
                            :color=" btnCategoryPressed == item.id ? colorRegistrateBackground : colorTramitesBtnBackground  "
                            depressed
                            @click="btnCategoriaClick(item.id, index)" 
                            elevation="4"
                            min-width="200px"
                            max-width="215px"
                            style="border-radius:8px"
                            class="mx-4 align-content-center align-center d-flex flex-column zoom-on-hover btn-category mobile-catergory"
                            >
                                <div :color="colorTramitesBtnBackground" tile flat class="align-content-center align-center btn-helpter-mobile" >
                                    <v-img
                                    class="mx-auto my-3 px-6 align-center align-content-center mobile-catergory-img"
                                    plain
                                    contain
                                    min-width="60%"
                                    max-width="60%"
                                    :src="item.icono" 
                                    />  
                                    
                                    
                                    <p class="flex-column mobile-catergory-text   montserrat-semi-bold text-wrap"  :color="colorLetraTramites" style="color:#ff8400" >
                                    {{item.nombre}}
                                    </p>
                                </div>
                            </v-btn>


                            

                        </v-card>
                </div>
            

            <sliderv v-if="processesStore.AllProcessByCategoryHome" :data="processesStore.AllProcessByCategoryHome[btnCategoryPressed-1]" ></sliderv>


        </div>
        <!-- cuadricula imagen -->
        <div>

            <v-card 
            color="white"
            flat
            class="pt-16"
            style="z-index:1"
            >
                <v-card
                class="d-flex justify-center text-center "
                flat
                width="100%"
                color="transparent"
                >
                    <div  class="background-up" ></div>
                    <div  class="background-down"></div>

                    <v-img
                    v-if="!isTablet"
                    class="mx-16 max-width-beneficios"
                    src="../../assets/img/compu-colores-new.webp"
                    ></v-img>
                    <v-img
                    v-else
                    class="mx-16"   
                    height="100%"
                    width="100%"
                    style="z-index:1"
                    src="../../assets/img/tramites-colores.webp"
                    ></v-img>
                
                </v-card>

            </v-card>
                
            <v-card  v-if="isMobile" :color="colorConsultarBackground">
              <div class="d-flex justify-center text-center py-5 mx-3 ">Solicita tu trámite o servicio desde tu hogar, oficina o tu celular.</div>
                 
            </v-card> 

        </div>   
        <!-- separador registrate con boton -->
        <div>

            <v-card 
            flat 
            tile
            width="100%" 
            class="d-flex flex-row justify-center" 
            :color="colorRegistrateBackground"
            height="100px"
            >
                <v-card 
                class="white--text d-flex align-self-center"
                flat
                tile
                :color="colorRegistrateBackground"
                >
                    <h1 class="align-self-center white--text text-h4  poppinsRegular mobile-registrate-text " v-if="!isMobile">{{registrate.text}}</h1>           
                     <v-btn class="mx-8 px-12 white--text text-h5 montserrat mobile-registrate-button" :color="colorRegistrateBtnBackground" @click="goRegister()" >
                        {{registrate.btn}}
                    </v-btn>
                </v-card>
            </v-card>

        </div>
        <!-- tramites mas frecuentes -->
        <div style="width:100%;background-color:#fff5d3" >
            <div style="background-color:#fff5d3;max-width:1500px;margin-left:auto;margin-right:auto;">
            <!-- titulo -->
                <v-card
                :color="colorTramitesBtnBackground"
                class="pl-16 pt-16 font-weight-black text-h3 montserrat-semi-bold mobile-tf-title"
                tile 
                flat
                >
                TRÁMITES MÁS FRECUENTES
                <div class="linea-aux"></div>
                </v-card>


                <div class="celular-contenedor mobile-tf-background">
                    <div class="celular-derecha mobile-tf-cel"></div>
                </div>

                    <!-- cuadricula de los tramites -->
                <div 
                :color="colorTramitesBtnBackground"
                class="d-flex justify-center align-center pl-16 mobile-tf-grid pb-16"
                height="100%"
                flat
                tile
                style="width:75%"
                >
                    <v-row
                    class="pt-10 d-flex align-start"
                    >
                        <v-col
                        v-for="(item , index) in processesStore.FrequentProcedure"
                        :key="index"
                        cols="12"
                        sm="4"                
                        class="d-flex flex-row justify-center align-start"
                        >

                            <v-card
                            class="py-5 align-center align-content-center"
                            :color="colortransparent"
                            flat
                            >
                                <v-card
                                width="250px"
                                flat
                                :color="colortransparent"
                                class="d-flex flex-column align-center align-content-center"
                                >
                                    <v-img v-if="item.icon"
                                        class=" align-center align-content-center mx-1 my-1 mobile-tf-img "
                                        plain
                                        width="31vw"
                                        max-width="125px"
                                        contain
                                        :lazy-src="require(`../../assets/img/maletin-default.webp`)"
                                        :src="item.icon" 
                                    >
                                    </v-img> 
                                    <v-img  v-else          
                                        active-class="success-nl"
                                        class="mx-auto  align-self-baseline  "
                                        plain
                                        style="object-fit: cover;display: block;"
                                        contain
                                        width="31vw"
                                        max-width="125px"
                                        :lazy-src="require(`../../assets/img/maletin-default.webp`)"
                                        :src="require(`../../assets/img/maletin-default.webp`)"
                                    />  
                                    <h1 class="text-h4 py-2 font-weight-bold caviarDreams mobile-tf-text">
                                    {{item.total}}
                                    </h1>
                                    <span class="align-center align-content-center text-h5 text-center mobile-tf-text">
                                        {{item.nombre}}
                                    </span>
                                </v-card>
                            </v-card>

                        </v-col>
                    </v-row>

                </div>

                <v-img
                v-if="isMobile"
                height="100%"
                width="90%"
                contain
                class="mx-auto"
                src="../../assets/img/movil.webp"
                >
                </v-img>
            </div>
        </div>


    </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import sliderv from '../components/SliderV.vue';


export default {
    data(){
        return{
            btnCategoryPressed: 1,
            colorPart2: '#fff5d3',
            colortransparent: 'rgb(239 232 221 / 0%)',
            itemsConsultar:[
                {text: 'Consulta la validez de tu documento' , textBtn: 'Aquí' },
                {text: 'Consulta el estatus de pago de tu trámite', textBtn: 'Aquí' }
            ],
            colorBtnHere: '#001b2b',
            colorConsultarBackground: '#efe9dd',
            colorTramitesBtnBackground: '#fff5d3',
            buttonsTramites:[
                {img : "iconos-categorias-02.svg", text : 'IDENTIDAD'},
                {img : "iconos-categorias-03.svg", text : 'EDUCACIÓN, CIENCIA Y TECNOLOGÍA'},
                {img : "iconos-categorias-04.svg", text : 'AGRICULTURA, GANADERÍA Y PESCA'},
                {img : "iconos-categorias-05.svg", text : 'PAGOS E IMPUESTOS'}
            ],
            colorLetraTramites: '#ff8400',
            slide:[],
            registrate:
                {text: '¡Regístrate y realiza tus trámites desde donde estés!' , btn : 'REGISTRATE'},
            colorRegistrateBackground: '#001b2b',
            colorRegistrateBtnBackground: '#ff8400',
            isMobile: false,
            isTablet: false,
            categoriasOrdenadas : []


            
        }
    },
    computed:{
        ...mapState({processesStore: state => state.processes}),
    },
    async mounted(){
        await this.getCategoriesHome()
        if(this.processesStore.categoriesHome){

        let categoriasSinOrdenar = this.processesStore.categoriesHome

        let ordenDeCategorias = categoriasSinOrdenar.map(categoria => categoria.orden).sort();
        
        ordenDeCategorias.forEach(orden => {
            let categoriaaOrdenar =  categoriasSinOrdenar.find(categoria => categoria.orden == orden)
            this.categoriasOrdenadas.push(categoriaaOrdenar)
        })
        // console.log(this.categoriasOrdenadas);

        this.getAllProcessByCategoryHome(1);
        }
    },
    methods:{
        ...mapActions('processes', ['getAllProcessByCategoryHome', 'getFrequentProcesses','getCategoriesHome']),

        goValidate(item){
            if(item == "Consulta la validez de tu documento"){
                this.$router.push({name: 'documents_validate'})

            }else{
                this.$router.push({name: 'paid_validate'})

            }
            this.$forceUpdate();
        },
        btnCategoriaClick(id, index){
            console.log(id);
            console.log(index);
            this.btnCategoryPressed = id;
            if(!this.processesStore.AllProcessByCategoryHome[index]){
                this.getAllProcessByCategoryHome(id);    
            }
            
            this.$forceUpdate();
        },
        goRegister(){
              this.$router.push({name: 'register'})
        },
        onResize() {
                if (window.innerWidth < 769){
                    this.isMobile = true;
                    this.$forceUpdate()
                }else{
                    this.isMobile = false;
                    this.$forceUpdate()
                } 
                if (window.innerWidth < 1024){
                    this.isTablet = true;
                    this.$forceUpdate()
                }else{
                    this.isTablet = false;
                    this.$forceUpdate()
                } 


            },
       
    },
    components:{
        sliderv
    },
    beforeMount(){
        this.getFrequentProcesses();
        this.$forceUpdate();

    }
}
</script>

<style scoped>
.min-height-mb{
    min-height: 40vw;
}
.linea-aux{
    width: 5%;
    background-color: #ff8400;
    height: 1rem;
}

.zoom-on-hover:hover{
    transform: scale(1.05) !important;
    z-index: 50;
    border-radius: 5px;
/* box-shadow: 0px 10px 10px 1px rgba(0, 0, 0, 0.568); */
    box-shadow: 0 8px 10px -6px rgba(0, 0, 0, 0.76);
}

.zoom-on-hover.v-btn:before{
    background-color: unset !important;
}

.background-up{
    background-color:#FFFFFF;
    position:absolute;
    height:45%;
    width:100%;
    z-index:1
}

.background-down{
    background-color:#efe9dd;
    position:absolute;
    bottom:0;
    height:55%;
    width:100%;
    z-index:1
}

.max-width-beneficios{
    max-width: 1300px;
    z-index:1;
    background-repeat: round;
    min-height:50%;
    max-height:80%;              
    width: 100%;
}

 .desktop-only{
    display: inherit ;
}

.mobile-only{
    display: none;
}

.hover-card:hover{
    transform: scale(1.05);
    transition: .5s;
    z-index: 2;
}

.nuevo-title{
    font-size:7vw;
    font-weight:1000;
    color:#ff8400;
    max-width:60% ;
    margin-left: 2%;
    z-index: 1;
    line-height: 90%;
    font-family: "BrandingSF-Black" !important;
}
.nuevo-title-black{
    font-size:7vw;
    font-weight:1000;
    color:#001b2b;
    max-width:60%;
    margin-left: 2%;
    z-index: 1;
    line-height: 90%;
    font-family: "BrandingSF-Black" !important;
}

.nuevo-sub-title{
    font-size:2vw;
    max-width:50%;
    margin-left: 2%;
    z-index: 1;
    font-family: "BrandingSF" !important;

}

.bttn-registrate-title{
    margin-left:2%; 
    font-size:15pt;
    padding-top: 24px !important;
    padding-bottom: 24px !important;
}

.success-nl{
    background-color: #fff5d3 ;
}

.separador-sombreado{
    width:70%;
    margin-left:auto; 
    margin-right:auto; 
    margin-bottom:20px; 
    margin-top:2%; 
    height:30px; 
    background-color:wwhite;
    box-shadow: black 0px 13px 12px -12px !important;
}

.bttn-consulta{
    color : #ff8400 !important;
}



.btn-category:target {
    background-color: cadetblue !important;
}


.forma-naranja{
    border-top-left-radius: 25% !important;
}

.forma-naranja::before{
    content: "";
    position:absolute;
    top:0px;
    left:-300px;
    right: 20px;
    height:300px;
    width: 300px;
    /* border-bottom-right-radius: 45%; */
    border-radius: 0% 0% 40% 0% / 70% 20% 60% 55%;
    background : rgba(0, 0, 0, 0);
    box-shadow: 10px 100px 0 0 #ff9d00;   
}


.forma-crema{
    border-bottom-left-radius: 25% !important;
}

.forma-crema::before{
    content: "";
    position:absolute;
    top:-1px;
    left:-300px;
    right: 20px;
    height:300px;
    width: 300px;
    /* border-bottom-right-radius: 45%; */
    border-radius: 50% 30% 0% 100% / 0% 50% 30% 50%;
    background : rgba(0, 0, 0, 0);
    box-shadow: 100px 0px 0 0 #fed5b4;   
}


.poppinsRegular{
    font-family: "PoppinsRegular" !important;

}

.poppins-medium{
    font-family: "PoppinsMedium" !important;
    font-size: 20pt;

}

.montserrat{  
    font-family: "Montserrat" !important;
}

.montserrat-semi-bold{
    font-family: "MontserratSemibold" !important;
}

.caviarDreams{
    font-family: "CaviarDreams" !important;
    font-size: 50pt;
}

.poppinsBold{
    font-family: "PoppinsBold" !important;
}

.celular-contenedor{
    height: 550px;
    right: 0;
    position: absolute;
    width: 25%;
    background-repeat: round;
}

.celular-derecha{
    margin-top: 18%;
    width: 90%;
    height: 100%;
    background-repeat: round;
    background-image: url(../../assets/img/cel-web.webp);
    margin-right: 0;
    margin-left: auto;
}

.categoria-tramites{
    margin-top:-5%;
    background-color:white;
    z-index:1;
    overflow:hidden
}


@media only screen and (max-width: 1000px) {

    
    .linea-aux{
        width: 12%;
        height: 5px;
    }


   ::-webkit-scrollbar {
        width: 0;  /* Remove scrollbar space */
        background: transparent;  /* Optional: just make scrollbar invisible */
    }

    .btn-helpter-mobile{
        width: 110px;
    }

    .background-up{
        height:45%;
    }

    .background-down{
        bottom:0;
        height:55%;
    }

    .max-width-beneficios{
        max-width: unset;
        width: 90%;
   }


    .mobile-slider{
        padding-top: 1rem !important;
    }

    .mobile-slider{
        width: 100% !important;
        max-width: 100% !important;
    }

    .categoria-tramites{
        margin-top: 1% !important;
        width: 100% !important;
    }   
    
    .mobile-catergory-img{
        min-width:85% !important ;
        max-width:100% !important
        
    }

    .mobile-catergory{
        min-width: 140px !important;
        min-height: 120px !important;
        margin: 0 .5rem !important
    }

    .overflow-scroll-x{
        overflow-x: scroll;
    }

    .min-height-mb{
        min-height: 65vh !important;
    }

    .personas-mobil{
        padding-left: 2rem !important;
        padding-top: 2rem !important;
    }

    .nuevo-title{
        margin-top: 0;
        font-size:3.2rem;
        margin-left: 0;
        width: 100%  !important;
        max-width:100%;

    }
    .nuevo-sub-title{
        font-size:.85rem;
        width: 100%;
        max-width: 65%;
        margin-left: 0;
    }

    .nuevo-title-black{
        font-size:3.1rem;
        margin-left: 0;
        width: 100%  !important;
        max-width:100%;
    }

    .bttn-registrate-title{
        /* position: absolute;
        margin-left:auto; 
        margin-right:auto; 
        right: 0;
        width: 60% !important;
        left: 0;
        bottom: 6.4rem; */
        z-index: 14;
        margin-left: 0;
        width: 60% !important;
        max-width: 180px;
        /* font-size:.9rem !important;
        padding-top: 19px !important;
        padding-bottom: 19px !important; */
    }


    .mobile-catergory-text{
        font-size: 10px;
        width: 130%;
        margin-left: -15px;
    }
    .mobile-catergory-img{
        width: 40px !important; 
    }

    .mobile-registrate-text{
        font-size: 11px !important;
        padding: 0 16px;
        line-height: 1rem;
        padding-top: 2px  !important;
        padding-bottom: 2px !important;
        padding-right: 10px !important;
        padding-left: 10px !important;
    }
    .mobile-registrate-button{
        /* font-size: 10px !important;
        padding: 0 16px;
        width: 100%;
        padding-top: 5px  !important;
        padding-bottom: 5px !important;
        padding-right: 10px !important;
        padding-left: 10px !important; */
    }

    .mobile-status-text{
        font-size: 10px;
        width: 100px !important;
        justify-content: space-around;
    }
    .mobile-status-background{
        height: 100px !important;
    }

    .mobile-status-btn{
        font-size: 10px;
        padding: 0 5 0 5 !important;
        width: 100%;
        margin: 0 0 0 0 !important
    }
    .mobile-status-text{
        font-size: 10px;
        padding: 0 0 0 0 !important;
        width: 50%;
        margin: 0 0 0 0 !important
    }

    .mobile-tf-title{
        padding-top: 2rem !important;
        padding-left: 12% !important;
        padding-right: auto !important;
        font-size: 2rem !important;
    }

    .mobile-tf-text{
        font-size: 1rem !important; 
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }  

    .mobile-tf-img{
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        flex: unset !important;
    }  

    .mobile-tf-grid{
        width: 100% !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    .mobile-tf-background{
        display: none;
        position: absolute    ;
        height: 40% !important;
        width: 80%;
        top: 0;
        bottom: 0;
        background-repeat: no-repeat !important;
        margin-top: auto; 
        margin-bottom: auto; 
        padding-left: auto !important;
        padding-right: 0 !important;
        right: 0 !important;
    }
    .mobile-tf-cel{
        display: none;
    }
    .mobile-hide{
        display: none;
    }

    .desktop-only{
        display: none ;
    }

    .mobile-only{
        display: inherit;
    }

}

@media screen and (min-width: 1600px) {
    .nuevo-title {
        font-size: 7.5rem;
    }
    .nuevo-title-black {
        font-size: 7.5rem;
    }
    .nuevo-sub-title{
        font-size: 1.5rem;
    }
    .categoria-tramites{
        margin-top:-7rem
    }
   
}

@media screen and (max-width: 1250px) {
    .mobile-registrate-text{
        font-size: 1rem !important;
    }
}

@media only screen and (max-width: 499px) {
     .mobile-tf-title{
        padding-top: 2rem !important;
        padding-left: auto !important;
        padding-right: auto !important;
        font-size: 1.3rem !important;
        line-height: inherit;

    }
    .personas-mobil{
        padding-left: 1rem !important;
        padding-right: auto !important;
    }
    .nuevo-title {
        font-size: 2.5rem;
        margin-top: -0.3rem!important;
    }
    .nuevo-title-black {
        font-size: 2.5rem;
    }
    .nuevo-sub-title{
        font-size: .7rem;
    }
}

@media only screen and (max-width: 1600px ) and ( min-width:780px) {
    .min-height-mb{
        /* min-height: 55vh !important; */
    }
}

@media only screen and (max-width: 650px ){
    .no-justify-center{
        justify-content: unset !important

    }
}
</style>
